// @file utilities for vote/rating field responses
import type { VoteOrRatingFieldValue } from '../types'

// Computes optimistic vote/rating field state when user creates, changes, or deletes their response.
export const getNewVoteOrRatingFieldData = (
  oldVoteFieldData: VoteOrRatingFieldValue | undefined,
  value: number | undefined,
) => {
  // Optimistically update the post's custom properties
  const oldUserResponse = oldVoteFieldData?.user_response
  const oldSum = oldVoteFieldData?.sum ?? 0
  const oldCount = oldVoteFieldData?.count ?? 0

  let newSum = oldSum
  let newCount = oldCount

  if (oldUserResponse != null && value == null) {
    // User deleting their response
    newSum = oldSum - oldUserResponse
    newCount = oldCount - 1
  } else if (oldUserResponse != null && value != null) {
    // User changing their response
    newSum = oldSum - oldUserResponse + value
    newCount = oldCount
  } else if (oldUserResponse == null && value != null) {
    // User creating a new response
    newSum = oldSum + value
    newCount = oldCount + 1
  }

  return {
    sum: newSum,
    count: newCount,
    user_response: value,
  }
}
